(function (angular) {
    angular.module('bizPartEngage').controller('core.notifications', notificationsController);

    notificationsController.$inject = ["core.users.service", "$state", "bizUser"];

    function notificationsController(userService, $state, bizUser) {
        var vm = this;
        vm.PageMax = 2000;
        vm.NotificationsPage = 1;

        vm.Settings = notificationSettings;

        vm.Init = Init;
        vm.GetLoggedInUserNotifications = GetLoggedInUserNotifications;
        vm.GoToItem = GoToItem;
        vm.Back = Back;        

        function Back() {
            window.history.back();
        }

        function GoToItem(item) {            
            //The types that only should be clickable for the users own items
            if ((item.Settings && ~~item.Settings.ObjectOwnerUserId > 0 && item.Settings.ObjectOwnerUserId === $rootScope.LoggedInUser.Id)) {
                switch (item.ObjectType) {
                    case 'GOAL':
                        $state.go("base.modules.goals.onegoal", { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
                        break;
                    case 'TODO':
                        $state.go("base.modules.goals.onetask", { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
                        break;
                    case 'ACTIVITY':
                        $state.go("base.modules.goals.activity", { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
                        break;
                }
            }

            //The types that should be clickable for any user (as long as they have access, which should be fixed on backend)
            switch (item.ObjectType) {
                case 'HTML5':
                    $state.go("base.modules.html5education", { id: item.ObjectId });
                    break;
                case 'MediabankFile':
                    $state.go("base.modules.mediafile", { id: item.ObjectId });
                    break;
                case 'Blog':
                    $state.go("base.modules.blog", { id: item.ObjectId });
                    break;
                case 'SCORM':
                    location.href = siteRootPath + "SCORM/" + item.ObjectId;
                    break;
            }    
        }

        function GetLoggedInUserNotifications(page) {
            userService.GetLoggedInUserNotifications(vm.PageMax, page).then(GetLoggedInUserNotificationsSuccess);

            function GetLoggedInUserNotificationsSuccess(response) {
                vm.Notifications = response.data;
            }
        }

        function Init() {
            vm.GetLoggedInUserNotifications(vm.NotificationsPage);
        }

        vm.$onInit = vm.Init;
    }
}(window.angular));